<template>
  <div class="gs-player-section">
    <div class="gs-switch-row">
      <span class="gs-switch-row__text">
        <span class="gs-switch-row__label">Show controls</span>
        <span class="gs-switch-row__help">
          The play, volume and progress bar viewers use.
        </span>
      </span>
      <gd-toggle v-model="model.settings.control" @change="showControls" />
    </div>

    <div v-if="model.video_source_type === 2" class="gs-switch-row">
      <span class="gs-switch-row__text">
        <span class="gs-switch-row__label">Show the YouTube control bar</span>
        <span class="gs-switch-row__help">
          Uses YouTube's own bar instead of your themed one.
        </span>
      </span>
      <gd-toggle
        :key="toggleKey"
        v-model="model.settings.ytControls"
        @change="changeYoutubeControls"
      />
    </div>

    <div class="gs-switch-row">
      <span class="gs-switch-row__text">
        <span class="gs-switch-row__label">{{ $t('frontend_groovevideo_videos_step1_show_overlay') }}</span>
        <span class="gs-switch-row__help">
          A line of text across the top of the video.
        </span>
      </span>
      <gd-toggle v-model="model.settings.overlay.enable" @change="changeOverlay()" />
    </div>

    <gs-field v-if="model.settings.overlay.enable == true" label="Overlay text">
      <input
        data-field="overlay-text"
        type="text"
        class="gs-player-section__input"
        :value="model.settings.overlay.txt"
        @input="setOverlayText($event.target.value)"
      />
    </gs-field>
  </div>
</template>

<script>
export default {
  name: 'ControlsSection',

  props: {
    model: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      // Ported from step2: the YouTube toggle is remounted so it always shows
      // the value the player actually settled on.
      toggleKey: 0,
      debounceTimer: null,
    };
  },

  beforeDestroy() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  },

  methods: {
    emitChange() {
      this.$emit('updateModel', this.model);
      this.$emit('forceRerender');
    },

    // Ported from step2.
    showControls() {
      this.$store.dispatch('videoVideoControl', this.model.settings.control);
      this.$store.dispatch('videoComponentKey');
      this.emitChange();
    },

    // Ported from step2.
    changeYoutubeControls() {
      this.toggleKey = this.toggleKey + 1;
      this.emitChange();
    },

    // Ported from step2.
    changeOverlay() {
      if (this.model.settings.overlay.enable) {
        this.$store.dispatch('videoOverlayText', this.model.settings.overlay.txt);
      }
      this.$store.dispatch('videoComponentKey');
      this.emitChange();
    },

    setOverlayText(value) {
      this.model.settings.overlay.txt = value;
      this.$emit('updateModel', this.model);
      // step2 debounced this field by a second: every change remounts the real
      // player, which is far too much work for one keystroke.
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.debounceTimer = null;
        this.changeOverlay();
      }, 1000);
    },
  },
};
</script>

<style scoped>
.gs-player-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 14px;
}

.gs-switch-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  padding: 14px 16px;
  background: var(--gs-surface-subtle);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
}

.gs-switch-row__text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.gs-switch-row__label {
  color: var(--gs-foreground);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
}

.gs-switch-row__help {
  max-width: 56ch;
  color: var(--gs-muted-foreground);
  font-size: 13px;
  line-height: 1.5;
}

.gs-player-section__input {
  display: block;
  width: 100%;
  min-height: 40px;
  padding: 10px 12px;
  color: var(--gs-foreground);
  background: var(--gs-input);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  font-size: 14px;
  line-height: 1.4;
}

.gs-player-section__input:focus {
  border-color: var(--gs-primary);
  outline: none;
  box-shadow: var(--gs-primary-shadow);
}
</style>
